import actions from './actions';

const { FORGOT_PASSWORD_BEGIN, FORGOT_PASSWORD_SUCCESS, FORGOT_PASSWORD_ERR } = actions;

const initState = {
  data: null,
  loading: false,
  error: null,
};

/**
 *
 * @todo impure state mutation/explaination
 */
const forgotPasswordReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case FORGOT_PASSWORD_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };
    case FORGOT_PASSWORD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default forgotPasswordReducer;
